import { useState } from "react"
import LoadingBalls from "../../core/loadingBalls";
import { sendEmailVerification } from "firebase/auth";
import { auth } from "../../../firebase";

export default function EmailVerifier() {

    const [loading, setLoading] = useState(false);
    const [sent, setSent] = useState(false);

    const doVerify = async () => {
        try {
            if(!auth.currentUser){
                return null;
            }
            setLoading(true);
            const siteUrl = process.env.REACT_APP_SITE_URL || window.location.origin;
            await sendEmailVerification(auth.currentUser, {
                url: `${siteUrl}/me/email-verificado`
            });
            setSent(true);
            setLoading(false);
        }catch(error){
            setLoading(false);
        }
    }

    return (
        <div>
            {
                sent ?
                    <div className="bg-green-50 border border-green-100 text-green-700 px-5 py-4 rounded-2xl shadow-sm flex flex-col gap-1 items-start max-w-[280px] animate-superfade">
                        <span className="text-[10px] font-black tracking-widest uppercase">Email Enviado!</span>
                        <span className="text-xs leading-tight font-medium">Verifique sua caixa de entrada e também a pasta de spam.</span>
                    </div>
                :
                <button onClick={doVerify} disabled={loading} className="px-6 py-3 border-2 border-primary text-primary font-black tracking-widest text-[10px] rounded-xl hover:bg-primary hover:text-white transition-all active:scale-95 flex items-center justify-center min-w-[150px]">
                {
                    loading ?
                    <LoadingBalls width={30} />
                    :
                    "CONFIRMAR EMAIL"
                }
            </button>
            }
        </div>
    )
}